export default {
    login: {
        title: 'Log in to your account',
        subtitle: 'Enter your credentials to access the admin panel',
        emailLabel: 'Email',
        emailPlaceholder: 'name@company.com',
        passwordLabel: 'Password',
        passwordPlaceholder: '••••••••',
        forgotPassword: 'Forgot password?',
        submitButton: 'Log in',
        noAccount: "Don't have an account?",
        contactAdmin: 'Contact administrator',
        credentialsTitle: 'Demo Credentials',
        errorInvalidCredentials: 'Invalid credentials',
        errorLogin: 'Error during login',
    },
    resetPassword: {
        title: 'Reset password',
        subtitle: 'Enter your email and we will send you a link to reset your password',
        emailLabel: 'Email',
        emailPlaceholder: 'name@company.com',
        submitButton: 'Send reset link',
        backToLogin: 'Back to login',
        successTitle: 'Email sent!',
        successMessage: 'We sent you a link to reset your password at',
        successInstructions: 'Check your inbox.',
        backToLoginButton: 'Back to Login',
        sendAnotherEmail: 'Send another email',
        errorRequest: 'Error requesting password reset. Please try again.',
        errorResend: 'Error resending email. Please try again.',
        resendSuccess: 'Email sent successfully!',
    },
    newPassword: {
        title: 'Set New Password',
        subtitle: 'Enter your new password below',
        verifying: 'Verifying reset token...',
        noToken: 'Reset token not provided',
        invalidToken: 'Invalid or expired reset token',
        errorTitle: 'Invalid Reset Token',
        backToLogin: 'Back to Login',
        passwordLabel: 'New Password',
        passwordPlaceholder: 'Enter new password (minimum 8 characters)',
        passwordConfirmLabel: 'Confirm New Password',
        passwordConfirmPlaceholder: 'Re-enter new password',
        passwordTooShort: 'Password must be at least 8 characters long',
        passwordsDoNotMatch: 'Passwords do not match',
        submitButton: 'Reset Password',
        resetError: 'Error resetting password. Please try again.',
        successTitle: 'Password Reset!',
        successMessage: 'Your password has been reset successfully. You can now log in with your new password.',
        redirecting: 'Redirecting to login...',
    },
    verifyInvitation: {
        title: 'Set up your password',
        titleExistingUser: 'Accept Invitation',
        subtitle: 'You have been invited to join {{companyName}}. Set up your password to complete registration.',
        email: 'Email: {{email}}',
        verifying: 'Verifying invitation...',
        noToken: 'Invitation token not provided',
        invalidToken: 'Invalid or expired invitation token',
        differentUser: 'This invitation is for a different user. Please log out and use the correct account.',
        errorTitle: 'Invalid Invitation',
        goToLogin: 'Go to Login',
        goToHome: 'Go to Home',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Enter password (minimum 8 characters)',
        passwordConfirmLabel: 'Confirm Password',
        passwordConfirmPlaceholder: 'Re-enter password',
        passwordTooShort: 'Password must be at least 8 characters long',
        passwordsDoNotMatch: 'Passwords do not match',
        submitButton: 'Set Password',
        setupError: 'Error setting up password',
        successTitle: 'Password Set!',
        successMessage: 'Your password has been set successfully. You can now log in.',
        redirecting: 'Redirecting to login...',
        existingUserMessage: 'You already have an account. Click below to accept the invitation and join this company.',
        acceptButton: 'Accept Invitation',
        acceptError: 'Error accepting invitation',
    },
};

